export default __webpack_public_path__ + "svg/calendar/2025/0/marzo.svg?2eeebe9b";